module.exports = __webpack_public_path__ + "img/3.5f79f79a.png";